function toSorted<T>(
  this: readonly T[],
  compareFn?: (left: T, right: T) => number,
): T[] {
  // This copied sort is the compatibility implementation of immutable toSorted().
  // oxlint-disable-next-line unicorn/no-array-sort
  return Array.from(this).sort(compareFn);
}

if (typeof Array.prototype.toSorted !== "function") {
  // This startup polyfill is required by supported browsers missing ES2023 toSorted().
  // oxlint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, "toSorted", {
    configurable: true,
    writable: true,
    value: toSorted,
  });
}
